@import "../use-bootstrap-mixins.scss";

.error_page {
  height: 100vh;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .header {
    font-size: 33px !important;
    font-weight: 400 !important;
    margin-bottom: 68px !important;
  }

  .p {
    font-size: 20px !important;
    font-weight: 700 !important;
  }

  .p1 {
    max-width: 450px;
    font-size: 14px;
  }

  button {
    max-width: 166px;
  }
}
